export const appName = 'I earn OK money, but still feel broke';

export const aiToolLinks = [
  { label: 'Open ChatGPT', href: 'https://chat.openai.com/' },
  { label: 'Open Claude', href: 'https://claude.ai/' },
  { label: 'Open Gemini', href: 'https://gemini.google.com/' },
  { label: 'Open Copilot', href: 'https://copilot.microsoft.com/' },
];

export const nextSteps = [
  { label: 'Try the budget calculator', href: '/budget-calculator' },
  { label: 'Check subscriptions', href: '/subscription-checker' },
  { label: 'Explore debt repayment methods', href: '/debt-snowball-vs-avalanche' },
  { label: 'Build an emergency fund', href: '/emergency-fund-calculator' },
  { label: 'Learn about compound interest', href: '/compound-interest-calculator' },
];

export const promptQuestions = [
  {
    id: 'primaryConcern',
    type: 'checkbox',
    label: 'What best describes your situation?',
    options: [
      'I earn decent money but have little left',
      'My bills are too high',
      'I keep overspending',
      'I do not know where my money goes',
      'I feel financially behind',
      'I am surviving, not progressing',
    ],
  },
  {
    id: 'pressureAreas',
    type: 'checkbox',
    label: 'What usually causes the pressure?',
    options: [
      'Rent or mortgage',
      'Food shopping',
      'Subscriptions',
      'Debt payments',
      'Children or family costs',
      'Social spending',
      'Impulse purchases',
      'Unexpected costs',
      'Helping other people',
      'Transport or car costs',
      'Not sure',
    ],
  },
  {
    id: 'paydayPattern',
    type: 'radio',
    label: 'What happens after payday?',
    options: [
      'Money disappears quickly',
      'I feel OK for a week, then stressed',
      'I pay bills and have little left',
      'I overspend because I feel relief',
      'I do not really track it',
      'My income is irregular, so payday is not simple',
    ],
  },
  {
    id: 'focusAreas',
    type: 'checkbox',
    label: 'What would you like the AI to focus on?',
    options: [
      'Practical money-saving ideas',
      'A realistic budgeting approach',
      'Emotional spending insights',
      'Help finding blind spots',
      'A 30-day reset plan',
      'Ways to feel more in control',
      'Better financial systems',
      'Questions I should ask myself',
    ],
  },
  {
    id: 'behaviouralFlags',
    type: 'checkbox',
    label: 'Are any of these familiar?',
    options: [
      'I spend more after payday',
      'I avoid checking my balance',
      'I use credit for essentials',
      'I feel guilty spending on myself',
      'Food spending is hard to control',
      'I overspend socially',
      'I buy things when stressed',
      'I buy things when tired',
      'I spend on children or family because of guilt',
      'I forget annual costs',
      'I run out before payday',
      'I move money between accounts often',
      'I use an overdraft regularly',
      'I may have subscription leaks',
    ],
  },
];

export const optionalContextFields = [
  { id: 'countryOrRegion', label: 'Country or region', inputMode: 'text' },
  { id: 'currency', label: 'Currency', inputMode: 'text' },
  { id: 'monthlyTakeHomeIncome', label: 'Monthly take-home income', inputMode: 'decimal' },
  { id: 'incomeFrequency', label: 'Income frequency', inputMode: 'text' },
  { id: 'monthlyRentOrMortgage', label: 'Monthly rent or mortgage', inputMode: 'decimal' },
  { id: 'monthlyDebtPayments', label: 'Monthly debt payments', inputMode: 'decimal' },
  { id: 'currentSavings', label: 'Current savings', inputMode: 'decimal' },
  { id: 'emergencyFundAmount', label: 'Emergency fund amount', inputMode: 'decimal' },
  { id: 'incomeStability', label: 'Income stability', inputMode: 'text' },
  { id: 'currentTrackingMethod', label: 'Current tracking method', inputMode: 'text' },
  {
    id: 'importantContext',
    label: 'Any important context',
    inputMode: 'text',
    multiline: true,
  },
];

export const createInitialAnswers = () => ({
  primaryConcern: [],
  pressureAreas: [],
  paydayPattern: '',
  focusAreas: [],
  behaviouralFlags: [],
  optionalContext: optionalContextFields.reduce(
    (fields, field) => ({ ...fields, [field.id]: '' }),
    {}
  ),
});
